import React from 'react'

const Preloader = () => {
  return (
    <div className="preloader-wrapper d-flex align-items-center justify-content-center">
        <div className="spinner-grow text-light" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    </div>
  )
}

export default Preloader;